var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isVisible)?_c('div',{staticClass:"loading-screen",attrs:{"data-test":"producer-loadingScreen"}},[_c('lottie',{attrs:{"height":150,"width":150,"options":_vm.options}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }